import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestNoticeLiteDelete = {
    path: "/notice/lite",
    method: RouteHttpVerb.DELETE
};
export { locationRestNoticeLiteDelete };
